import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { CheckCircle, Home } from "lucide-react";
import { toast } from "sonner";

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [paymentInfo, setPaymentInfo] = useState<any>(null);

  useEffect(() => {
    // Get payment information from URL params or localStorage
    const paymentType = searchParams.get("type") || "subscription";
    const amount = searchParams.get("amount");
    const businessType = searchParams.get("business_type");

    setPaymentInfo({
      type: paymentType,
      amount: amount,
      businessType: businessType
    });

    // Show success toast
    toast.success("Payment successful. You're now onboarded and can proceed with setup.");
  }, [searchParams]);

  const getSuccessMessage = () => {
    if (paymentInfo?.businessType) {
      return "Setup fee paid successfully! Your 7-day free trial has started. You can now access the full system.";
    } else if (paymentInfo?.type === "subscription") {
      return "Your subscription is now active. Welcome to NextWave AI!";
    }
    return "Payment completed successfully! You can now access all features.";
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md p-8">
        <div className="text-center space-y-6">
          <div className="space-y-4">
            <CheckCircle className="w-16 h-16 text-green-500 mx-auto animate-pulse" />
            <h1 className="text-2xl font-bold text-green-600">Payment Successful!</h1>
            <p className="text-muted-foreground">{getSuccessMessage()}</p>
            
            {paymentInfo?.amount && (
              <div className="bg-green-50 dark:bg-green-900/20 p-4 rounded-lg">
                <p className="text-sm text-green-700 dark:text-green-300">
                  Amount: ${paymentInfo.amount}
                </p>
              </div>
            )}
          </div>
          
          <div className="space-y-3">
            <Button 
              onClick={() => navigate("/")}
              className="w-full"
              size="lg"
            >
              <Home className="w-4 h-4 mr-2" />
              Go to Dashboard
            </Button>
            
            <Button 
              variant="outline"
              onClick={() => navigate("/pricing")}
              className="w-full"
            >
              View Plans
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default PaymentSuccess;